<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mdBPLU/tc-custom/9780292773226.jpg?1705766068840" alt="This image is the cover for the book Bat Bomb"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bat Bomb
      </h1>
      <p class="bookDescription body article font2">
        <b>“Inside information on a wondrously droll, highly classified yarn from WWII . . . A well-told, stranger-than-fiction tale that could make a terrific movie.” —<i>Kirkus Reviews</i></b><br/>  <br/> The plan: attach small incendiary bombs to millions of bats and release them over Japan’s major cities. As the bats went to roost, a million fires would flare up in remote crannies of the wood and paper buildings common throughout Japan. When their cities were reduced to ashes, the Japanese would surely capitulate . . .<br/>  <br/> Told here by the youngest member of the team, this is the story of the bat bomb project, or Project X-Ray, as it was officially known. In scenes worthy of a Capra or Hawks comedy, Jack Couffer recounts the unorthodox experiments carried out in the secrecy of Bandera, Texas, Carlsbad, New Mexico, and El Centro, California, in 1942-1943 by “Doc” Adams’ private army. This oddball cast of characters included an eccentric inventor, a distinguished Harvard scientist, a biologist with a chip on his shoulder, a movie star, a Texas guano collector, a crusty Marine Corps colonel, a Maine lobster fisherman, an ex-mobster, and a tiger.<br/>  <br/> The bat bomb researchers risked life and limb to explore uncharted bat caves and “recruit” thousands of bats to serve their country, certain that they could end the war with Japan. And they might have—in their first airborne test, the bat bombers burned an entire brand-new military airfield to the ground.<br/>  <br/> For everyone who relishes true tales of action and adventure, <i>Bat Bomb</i> is a must-read. Bat enthusiasts will also discover the beginnings of the scientific study of bats.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Couffer
      </h2>
      
      <p class="authorDescription body article">Since World War II Jack Couffer has pursued a career in film as a director,writer, producer, and cameraman. His work has appeared in numerous popular films, including Out of Africa, Ring of Bright Water, and Never Cry Wolf.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a7122b6e